<script>
  function scrollToTop(event) {
    // Prevent default link behavior
    event.preventDefault();
    // Scroll to the top of the page
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling effect
    });
  }
</script>

<div class="content">
  <footer>
    <div class="branding">
      <div class="logo">
        <a href="/">
          <img
            src="/PrimaryLogo.png"
            alt="TruLens"
            style="width: 200px; height: auto; background-color: #ffffff;"
          />
        </a>
      </div>
      <div class="social" style="margin-left: 10px;">
        <img
          src="/icons/linkedin.png"
          alt="linkedinLogo"
          width="20rem"
          height="20rem"
        />
        <img
          src="/icons/twitter.png"
          alt="twitterXLogo"
          width="20rem"
          height="20rem"
        />
        <img
          src="/icons/instagram.png"
          alt="instagramLogo"
          width="20rem"
          height="20rem"
        />
        <img
          src="/icons/facebook.png"
          alt="facebookLogo"
          width="20rem"
          height="20rem"
        />
      </div>
    </div>
    <div class="links">
      <div class="company">
        <h3 class="title">Company</h3>
        <!-- Add the scrollToTop function to the About Us and Careers links -->
        <a href="#/landing" on:click={scrollToTop}>
          <span>About us</span>
        </a>
        <a href="#/landing" on:click={scrollToTop}>
          <span>Careers</span>
        </a>
        <a href="#/contact-us">
          <span>Contact us</span>
        </a>
      </div>
      <div class="legal">
        <h3 class="title">Legal</h3>
        <a href="#/privacy-policy">
          <span>Privacy policy</span>
        </a>
        <a href="#/security-policy">
          <span>Security policy</span>
        </a>
        <a href="#/terms-and-conditions">
          <span>Terms & conditions</span>
        </a>
      </div>
    </div>
  </footer>
</div>

<style>
  footer {
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    flex-wrap: wrap; /* Allow items to wrap on smaller screens */
    justify-content: space-between;
    align-items: center;
    padding: 10px 5%;
    background: white;
    color: #000000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.6);
    z-index: 1000;
  }

  .content {
    padding-top: 60px;
    max-width: 100%;
    overflow-x: hidden; /* Prevent horizontal scroll */
  }

  .branding {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    padding: 1rem 0;
    font-size: 1.5rem;
    font-weight: bold;
    color: #1e92ff;
    max-width: 100%;
  }

  .social {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    padding-left: 0.3rem;
    max-width: 100%;
  }

  .links {
    display: flex;
    flex-wrap: wrap; /* Wrap items on smaller screens */
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    max-width: 100%;
    padding-right: 10%;
  }

  .company,
  .legal {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    max-width: 100%;
  }

  .company a,
  .legal a {
    text-decoration: none !important;
    color: #000000;
    transition: color 0.3s; /* Smooth transition for hover effect */
  }

  /* Change color on hover */
  .company a:hover,
  .legal a:hover {
    color: #ff3c82; /* Change this color to any highlight color you like */
  }

  /* Change color when clicked */
  .company a:active,
  .legal a:active {
    color: #1e92ff; /* Blue color when clicked */
  }

  @media (max-width: 768px) {
    footer {
      height: auto;
      padding: 15px;
      flex-direction: column; /* Stack items vertically on mobile */
      align-items: flex-start;
    }

    .branding {
      margin-left: 0;
      font-size: 1rem;
    }

    .links {
      flex-direction: column;
      gap: 15px;
      align-items: flex-start;
      padding-right: 0;
    }
  }
</style>
